// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDce5IWXuCrxAKUBh5maGSj3TERjqSJnu4",
  authDomain: "yess-web-app.firebaseapp.com",
  projectId: "yess-web-app",
  storageBucket: "yess-web-app.firebasestorage.app",
  messagingSenderId: "194550700879",
  appId: "1:194550700879:web:073d37940a81bcf43ac33a",
  measurementId: "G-0WST59XYL4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
